export default __webpack_public_path__ + "static/media/brouilleur.205c149a.png";